export class RecruitSliderControls {
  constructor(sliders) {
    if (!sliders || sliders.length === 0) return
    this.sliders = sliders.filter((slider) => {
      const { page } = slider.container.dataset
      return page === 'recruit'
    })
    if (this.sliders.length === 0) return
    this.sliders.forEach((slider) => {
      if (slider.track.details.slidesLength <= 1) return
      const { controls, next, prev, progress, progressBar } = this.createControls()
      slider.container.parentNode.parentNode.appendChild(controls)
      prev.addEventListener('click', () => slider.prev())
      next.addEventListener('click', () => slider.next())
      progressBar.style.width = '0%'
      prev.disabled = slider.track.details.rel === 0
      slider.on('slideChanged', () => {
        prev.disabled = slider.track.details.rel === 0
        next.disabled = slider.track.details.rel === slider.track.details.maxIdx
      })
      if (slider.container.dataset.progress !== undefined) {
        controls.appendChild(progress)
        slider.on('detailsChanged', (s) => {
          progressBar.style.width = `${Math.min(1, Math.max(0, slider.track.details.progress)) * 100}%`
        })
      }
    })
  }
  createControls() {
    const controls = document.createElement('div')
    controls.className = 'p-recruit__slider__controls'
    const prev = this.createButton('p-recruit__slider__button -prev')
    const next = this.createButton('p-recruit__slider__button -next')
    controls.appendChild(prev)
    controls.appendChild(next)

    const progress = document.createElement('span')
    progress.className = 'p-recruit__slider__progress'
    const progressBar = document.createElement('span')
    progressBar.className = 'bar'
    progress.appendChild(progressBar)
    return {
      controls,
      prev,
      next,
      progress,
      progressBar,
    }
  }
  createButton(className) {
    const button = document.createElement('button')
    button.type = 'button'
    button.className = className
    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currentColor" d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"/></svg>`

    return button
  }
}
